'use client'

import type { BannerLinkProps } from '@maestro/commerce-blocks/components/banner/banner.types'

import React, { useCallback } from 'react'

import { useEventBusContext } from '@maestro/core/event/event-bus.context'
import { EventType } from '@maestro/data-layer'
import { Link } from '@pearlconvert/ui/components/link'
import { useModalLink } from '@pearlconvert/ui/hooks/use-modal-link'

export default function BannerLink({
  href,
  target,
  className,
  eventPayload,
  children,
  ariaLabel,
}: BannerLinkProps) {
  const { publish } = useEventBusContext()
  const { url, handleClick: handleClickBanner } = useModalLink({
    url: href,
    blank: target === '_blank',
  })

  const handleClick = useCallback(() => {
    publish(EventType.PROMOTION_SELECTED, eventPayload)
  }, [eventPayload, publish])

  return (
    <Link
      href={url}
      target={target}
      className={className}
      aria-label={ariaLabel}
      onClick={(e) => {
        handleClick()
        handleClickBanner(e)
      }}
    >
      {children}
    </Link>
  )
}
